module.exports = __webpack_public_path__ + "static/media/attitude.48a648cf.png";